import * as React from 'react';

import ConfirmAddress from './ConfirmAddress';

import * as api from '../../api';

import { AddressPicker } from './AddressPicker';
import { useVerifyAddress } from '../../hooks/address/useVerifyAddress';

interface Props {
  address: api.Places.PlaceDetails;
  onSave: (place: api.Places.PlaceDetails) => void;
}

export const VerifyAddressContainer: React.FC<Props> = ({
  address,
  onSave,
}) => {
  const { suggestedAddress, missingUnit, error, verify, updatedAddress } =
    useVerifyAddress(onSave);
  if (!suggestedAddress || !updatedAddress) {
    return (
      <ConfirmAddress
        place={address}
        onSave={verify}
        missingUnit={missingUnit}
        error={error}
      />
    );
  }
  return (
    <AddressPicker
      originalAddress={updatedAddress}
      suggestedAddress={suggestedAddress}
      onAddressSelected={onSave}
    />
  );
};
